<app-header [assistanceState]="assistanceState" [assistancePriority]="assistancePriority" (membersSwitch)="switchMembers()" (assistancesSwitch)="switchAssistances()" (commentsSwitch)="switchComments()"></app-header>
<div class="fullWaitingAsset">
  <div class="background">
    <div class="two-colums">
      <div class="blue-area participants">

        <!-- sala padre -->
        <!-- experto -->
        @if (userDataService.assetInfo.parentId == 0 && isExpert) {
          <mat-tab-group animationDuration="0ms" class="resposive-off">
            <mat-tab label="{{'PARTICIPANTS' | translate}}">
              <directCall-members class="resposive-off" [stickyMode]="true"></directCall-members>
            </mat-tab>
            <mat-tab label="{{'ASSISTANCES.TOOL_TIP' | translate}}">
              <directCall-assistances class="resposive-off" [stickyMode]="true"></directCall-assistances>
            </mat-tab>
            <mat-tab label="{{'COMMENTS.TOOL_TIP' | translate}}">
              <directCall-comments class="resposive-off" [stickyMode]="true"></directCall-comments>
            </mat-tab>
          </mat-tab-group>
        }

        <!-- tech -->
        @if (userDataService.assetInfo.parentId == 0 && !isExpert) {
          <directCall-members class="resposive-off" [stickyMode]="true"></directCall-members>
        }

        <!-- responsive -->
        @if (userDataService.assetInfo.parentId == 0 && members) {
          <directCall-members class="resposive-on" [withMenu]="true" (close)="switchMembers()"></directCall-members>
        }
        @if (userDataService.assetInfo.parentId == 0 && assistances) {
          <directCall-assistances class="resposive-on" [withMenu]="true" (close)="switchAssistances()"></directCall-assistances>
        }
        @if (userDataService.assetInfo.parentId == 0 && comments) {
          <directCall-comments class="resposive-on" [withMenu]="true" (close)="switchComments()"></directCall-comments>
        }


        <!-- sala assistencia -->
        @if (userDataService.assetInfo.parentId > 0 && isExpert) {
          <mat-tab-group animationDuration="0ms" class="resposive-off">
            <mat-tab label="{{'PARTICIPANTS' | translate}}">
              <directCall-members class="resposive-off" [stickyMode]="true"></directCall-members>
            </mat-tab>
            <mat-tab label="{{'COMMENTS.TOOL_TIP' | translate}}">
              <directCall-comments class="resposive-off" [stickyMode]="true"></directCall-comments>
            </mat-tab>
          </mat-tab-group>
        }

        <!-- tech -->
        @if (userDataService.assetInfo.parentId > 0 && !isExpert) {
          <directCall-members class="resposive-off" [stickyMode]="true"></directCall-members>
        }

        <!-- responsive -->
        @if (userDataService.assetInfo.parentId > 0 && members) {
          <directCall-members class="resposive-on" [withMenu]="true" (close)="switchMembers()"></directCall-members>
        }
        @if (userDataService.assetInfo.parentId > 0 && comments) {
          <directCall-comments class="resposive-on" [withMenu]="true" (close)="switchComments()"></directCall-comments>
        }

      </div>
      <div class="blue-area chat" id="chatContainer">
        <directCall-chat [stickyMode]="true"></directCall-chat>
      </div>
    </div>
  </div>
</div>

